/* slop shop — storefront behavior. No dependencies. */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    var s = (cents / 100).toFixed(2);
    return '$' + (s.indexOf('.00') === s.length - 3 ? s.slice(0, -3) : s);
  };

  /* ------------------------------------------------------------------
     COUNTDOWN — absolute, read from body[data-retire]. Never resets.
     ------------------------------------------------------------------ */
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  function renderCountdown() {
    var iso = document.body.getAttribute('data-retire');
    if (!iso) return;
    var end = new Date(iso).getTime();
    if (isNaN(end)) return;
    var t = Math.max(0, end - Date.now());
    var d = Math.floor(t / 864e5),
        h = Math.floor(t / 36e5) % 24,
        m = Math.floor(t / 6e4) % 60,
        s = Math.floor(t / 1e3) % 60;
    var map = {
      short: d + 'D ' + h + 'H',
      long:  d + 'D ' + h + 'H ' + pad(m) + 'M',
      d: String(d), h: String(h),
      dd: pad(d), hh: pad(h), mm: pad(m), ss: pad(s)
    };
    $$('[data-cd]').forEach(function (el) {
      var v = map[el.getAttribute('data-cd')];
      if (v !== undefined && el.textContent !== v) el.textContent = v;
    });
  }

  /* ------------------------------------------------------------------
     MODALS
     ------------------------------------------------------------------ */
  function openModal(el) {
    if (!el) return;
    el.hidden = false;
    document.body.style.overflow = 'hidden';
    var x = $('.modal-x', el);
    if (x) x.focus();
  }
  function closeModal(el) {
    if (!el) return;
    el.hidden = true;
    if (!$$('.overlay:not([hidden])').length) document.body.style.overflow = '';
  }
  function closeAll() { $$('.overlay').forEach(closeModal); }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* ------------------------------------------------------------------
     CART — real Shopify cart, redrawn via the Section Rendering API
     ------------------------------------------------------------------ */
  function refreshCart(andOpen) {
    return fetch(window.Slop.routes.root + '?sections=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('#cart-drawer', doc);
        var live = $('#cart-drawer');
        if (!fresh || !live) return;

        var wasOpen = !live.hidden;
        live.innerHTML = fresh.innerHTML;

        var count = fresh.getAttribute('data-count');
        live.setAttribute('data-count', count);
        $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
        $$('[data-cart-items]').forEach(function (el) { el.textContent = count + ' item(s)'; });

        if (andOpen || wasOpen) openModal(live);
      });
  }

  function cartError(msg) {
    var box = $('#cart-error');
    if (box) { box.textContent = msg; box.hidden = false; }
    else window.alert(msg);
  }

  function addToCart(id, qty) {
    return fetch(window.Slop.routes.add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { cartError(res.body.description || res.body.message || 'Could not add that.'); return; }
        return refreshCart(true);
      })
      .catch(function () { cartError('Network error. Try again.'); });
  }

  function changeLine(key, qty) {
    return fetch(window.Slop.routes.change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function () { return refreshCart(false); })
      .catch(function () { cartError('Network error. Try again.'); });
  }

  /* ------------------------------------------------------------------
     SIZE PICKER — quick add from any product card
     ------------------------------------------------------------------ */
  function openPicker(card) {
    var raw = $('script.card-data', card);
    if (!raw) return;
    var d;
    try { d = JSON.parse(raw.textContent); } catch (e) { return; }

    var modal = $('#size-picker');
    if (!modal) return;

    $('[data-pick-name]', modal).textContent = d.title;
    $('[data-pick-meta]', modal).textContent = d.price + ' — ' + (d.blank || '1717 HEAVYWEIGHT');

    var thumb = $('[data-pick-thumb]', modal);
    thumb.style.background = d.garment || '#14120F';
    thumb.innerHTML = '';
    if (d.image) {
      var img = document.createElement('img');
      img.src = d.image; img.alt = ''; thumb.appendChild(img);
    } else {
      var sp = document.createElement('span');
      sp.style.color = d.ink || '#F5F3EE';
      sp.textContent = d.headline || d.title;
      thumb.appendChild(sp);
    }

    var row = $('[data-pick-sizes]', modal);
    row.innerHTML = '';
    d.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'size up';
      b.style.minWidth = '48px';
      b.style.height = '46px';
      b.textContent = v.size;
      if (!v.available) { b.disabled = true; }
      else {
        b.addEventListener('click', function () {
          closeModal(modal);
          addToCart(v.id, 1);
        });
      }
      row.appendChild(b);
    });

    openModal(modal);
  }

  /* ------------------------------------------------------------------
     PDP — size + color select a real variant
     ------------------------------------------------------------------ */
  function initProductForm() {
    var form = $('#pdp-form');
    if (!form) return;
    var raw = $('#pdp-variants');
    if (!raw) return;
    var variants;
    try { variants = JSON.parse(raw.textContent); } catch (e) { return; }

    var idInput = $('[name="id"]', form);
    var btn = $('[data-add-btn]');
    var btnMobile = $('[data-add-btn-mobile]');
    var priceEl = $('[data-pdp-price]');
    var comparEl = $('[data-pdp-compare]');
    var sizeLabel = $('[data-size-label]');
    var colorLabel = $('[data-color-label]');
    var bundleBtn = $('[data-add-bundle]');

    var state = { size: form.getAttribute('data-size'), color: form.getAttribute('data-color') };

    function match() {
      return variants.filter(function (v) {
        return (!state.size || v.size === state.size) && (!state.color || v.color === state.color);
      })[0];
    }

    function paint() {
      var v = match();
      if (sizeLabel) sizeLabel.textContent = state.size || '—';
      if (colorLabel) colorLabel.textContent = state.color || '—';

      // grey any size with no available variant in the chosen color
      $$('[data-size]').forEach(function (b) {
        var sz = b.getAttribute('data-size');
        var any = variants.filter(function (x) {
          return x.size === sz && (!state.color || x.color === state.color) && x.available;
        }).length;
        b.disabled = !any;
        b.setAttribute('aria-pressed', String(sz === state.size));
      });
      $$('[data-color]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-color') === state.color));
      });

      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
        if (btnMobile) btnMobile.disabled = true;
        if (bundleBtn) bundleBtn.hidden = true;
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (comparEl) {
        if (v.compare && v.compare > v.price) { comparEl.textContent = money(v.compare); comparEl.hidden = false; }
        else comparEl.hidden = true;
      }
      var ok = v.available;
      if (btn) {
        btn.disabled = !ok;
        btn.textContent = ok ? 'Add to cart — ' + money(v.price) : 'Sold out';
      }
      if (btnMobile) btnMobile.disabled = !ok;
      if (bundleBtn) { bundleBtn.hidden = !ok; bundleBtn.setAttribute('data-add-bundle', v.id); }
    }

    $$('[data-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        state.size = b.getAttribute('data-size');
        paint();
      });
    });
    $$('[data-color]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.color = b.getAttribute('data-color');
        paint();
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = match();
      if (v && v.available) addToCart(v.id, 1);
    });

    if (bundleBtn) {
      bundleBtn.addEventListener('click', function () {
        var v = match();
        if (v && v.available) addToCart(v.id, 2);
      });
    }

    paint();
  }

  /* ------------------------------------------------------------------
     SHOP ALL — filter the grid by a size that is actually in stock
     ------------------------------------------------------------------ */
  function initFilter() {
    var bar = $('[data-filter-bar]');
    if (!bar) return;
    var out = $('[data-filter-count]');
    var cards = $$('[data-card-sizes]');

    function apply(sz) {
      var shown = 0;
      cards.forEach(function (c) {
        var list = (c.getAttribute('data-card-sizes') || '').split(',');
        var hit = sz === 'ALL' || list.indexOf(sz) > -1;
        c.hidden = !hit;
        if (hit) shown++;
      });
      if (out) out.textContent = shown;
      $$('[data-filter]', bar).forEach(function (b) {
        var on = b.getAttribute('data-filter') === sz;
        b.setAttribute('aria-pressed', String(on));
        b.className = 'btn ' + (on ? 'in' : 'up');
        b.style.background = on ? '#000080' : '#C0C0C0';
        b.style.color = on ? '#FFFFFF' : '#000000';
      });
    }

    $$('[data-filter]', bar).forEach(function (b) {
      b.addEventListener('click', function () { apply(b.getAttribute('data-filter')); });
    });
    apply('ALL');
  }

  /* ------------------------------------------------------------------
     ACCORDION + TABS
     ------------------------------------------------------------------ */
  function initAccordion() {
    $$('[data-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') === 'true';
        var group = btn.closest('[data-acc-group]');
        if (group) {
          $$('[data-acc]', group).forEach(function (o) {
            o.setAttribute('aria-expanded', 'false');
            var p = document.getElementById(o.getAttribute('aria-controls'));
            if (p) p.hidden = true;
            var sign = $('[data-sign]', o);
            if (sign) sign.textContent = '+';
          });
        }
        if (!open) {
          btn.setAttribute('aria-expanded', 'true');
          if (panel) panel.hidden = false;
          var sg = $('[data-sign]', btn);
          if (sg) sg.textContent = '−';
        }
      });
    });
  }

  function initTabs() {
    $$('[data-tab-group]').forEach(function (group) {
      var tabs = $$('[data-tab]', group);
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) {
            var on = o === t;
            o.setAttribute('aria-selected', String(on));
            o.className = 'btn ' + (on ? 'in' : 'up');
            o.style.background = on ? '#FFFFFF' : '#C0C0C0';
            var p = document.getElementById(o.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     HERO SLIDESHOW — cross-fades between however many slides exist
     ------------------------------------------------------------------ */
  function initHero() {
    $$('[data-hero-cycle]').forEach(function (box) {
      var slides = $$('.hero-slide', box);
      if (slides.length < 2) {
        if (slides[0]) slides[0].hidden = false;
        return;
      }
      var secs = Number(box.getAttribute('data-hero-cycle')) || 5;
      var i = 0;
      slides.forEach(function (s, n) {
        s.hidden = false;
        s.style.opacity = n === 0 ? '1' : '0';
        s.style.zIndex = n === 0 ? '1' : '0';
      });
      setInterval(function () {
        var prev = slides[i];
        i = (i + 1) % slides.length;
        var next = slides[i];
        next.style.zIndex = '1';
        next.style.opacity = '1';
        prev.style.opacity = '0';
        prev.style.zIndex = '0';
      }, secs * 1000);
    });
  }

  /* ------------------------------------------------------------------
     HIT COUNTER — decorative, stable within a day
     ------------------------------------------------------------------ */
  function initCounter() {
    var el = $('[data-hits]');
    if (!el) return;
    var base = Number(el.getAttribute('data-hits')) || 47213;
    var days = Math.floor(Date.now() / 864e5);
    var n = base + (days % 9999) * 3;
    el.textContent = String(n).padStart(8, '0');
  }

  /* ------------------------------------------------------------------
     WIRING
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var openBtn = t.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); openModal($('#cart-drawer')); return; }

    if (t.closest('[data-close]')) { e.preventDefault(); closeAll(); return; }

    var quick = t.closest('[data-quick]');
    if (quick) { e.preventDefault(); openPicker(quick.closest('[data-card]')); return; }

    var q = t.closest('[data-qty]');
    if (q) {
      e.preventDefault();
      changeLine(q.getAttribute('data-key'), Number(q.getAttribute('data-qty')));
      return;
    }

    var quickAddId = t.closest('[data-add-id]');
    if (quickAddId) { e.preventDefault(); addToCart(quickAddId.getAttribute('data-add-id'), 1); return; }
  });

  function boot() {
    renderCountdown();
    setInterval(renderCountdown, 1000);
    initProductForm();
    initFilter();
    initAccordion();
    initTabs();
    initCounter();
    initHero();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.Slop = window.Slop || {};
  window.Slop.refreshCart = refreshCart;
})();
